import React from 'react';
import {Routes, Route} from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Welcome from "./components/Welcome";
import PosterGenerator from './components/PosterGenerator/PosterGenerator';
import AuthPage from "./components/AuthPage";
import './App.css';
import './index.css';

function App() {
    return (
        <div className="App">
            <Header/>
            <Routes>
                <Route path="/" element={<Welcome/>}/>
                <Route path="/home" element={<PosterGenerator/>}/>
                <Route path="/auth" element={<AuthPage/>}/>
            </Routes>
            <Footer/>
        </div>
    );
}

export default App;